// Single source of truth for the NEET-Leaders-batch discount so the payment
// page, dashboard, and application review page can never drift out of sync.

export const readStoredZohoData = () => {
  try {
    const stored = localStorage.getItem('zohoCRMData');
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

export const computeApplicationFee = (zohoData) => {
  const zd = zohoData || {};
  const classLookingForCandidates = {
    'leadData.Class_Looking_For': zd.leadData?.Class_Looking_For,
    'applicationData.Class_applying_for': zd.applicationData?.Class_applying_for,
    'leadData.Grade_Applying': zd.leadData?.Grade_Applying,
    'applicationData.Grade_Applying': zd.applicationData?.Grade_Applying,
    'formData.gradeApplying': zd.formData?.gradeApplying
  };
  const classLookingForValues = Object.values(classLookingForCandidates).filter(v => v != null && v !== '');
  // Zoho's picklist label for this batch has shown up as both "NEET ..." and
  // plain "Leaders Batch" (no "NEET" in the string) — match either so a label
  // change on the CRM side doesn't silently fall back to the standard fee.
  const isNEETLeadersBatch = classLookingForValues.some(v => {
    const normalized = String(v).trim().toLowerCase();
    return normalized.includes('neet') || normalized.includes('leaders');
  });

  return {
    classLookingForCandidates,
    classLookingFor: classLookingForValues[0] || '',
    isNEETLeadersBatch,
    applicationFeeAmount: isNEETLeadersBatch ? 107200 : 307200,
    applicationFeeDisplay: isNEETLeadersBatch ? '₹1,072' : '₹3,072'
  };
};
